import { redirect } from 'react-router-dom'

/** Shared proforma links sent before the slug was renamed to match the rest of the platform. */
export const LEGACY_PROFORMA_PATHNAME = '/shared/v2/:quoteId/proforma/:action?'

/**
 * redirectLegacyProforma - Route loader that sends an old `/proforma` shared link to the
 * `/proforma-invoice` page, keeping the action (e.g. `export`). Customers still hold the old
 * spelling in their inboxes.
 *
 * @param {{ params: { quoteId: string, action?: string } }} args
 * @returns {Response} The redirect.
 */
export const redirectLegacyProforma = ({ params: { action, quoteId } }) =>
    redirect(`/shared/v2/${quoteId}/proforma-invoice${action ? `/${action}` : ''}`)
